import { render, staticRenderFns } from "./Feature.vue?vue&type=template&id=6ecce528&scoped=true"
import script from "./Feature.vue?vue&type=script&lang=js"
export * from "./Feature.vue?vue&type=script&lang=js"
import style0 from "./Feature.vue?vue&type=style&index=0&id=6ecce528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecce528",
  null
  
)

export default component.exports